export const SCREEN = {
    PATIENT_DETAILS: 'PATIENT_DETAILS',
    ADD_PERSON: 'ADD_PERSON',
    INSURANCE: 'INSURANCE',
    BEHAVIRIOAL_QUESTIONS: 'BEHAVIRIOAL_QUESTIONS',
    ADD_PATIENT: 'ADD_PATIENT',
}

export const TABS = [
    {
        key: SCREEN.PATIENT_DETAILS,
        value: 'Patient Details',
    },
    { key: SCREEN.ADD_PERSON, value: 'Add Person' },
    { key: SCREEN.INSURANCE, value: 'Insurance' },
]

export const PATIENT_TYPE = {
    CHILD: 'child',
    ADULT: 'adult',
}

export const ANSWER_TYPE = {
    YES: 'Yes',
    NO: 'No',
}

export const QUESTION1 = 'Do you currently have suicidal thoughts or thoughts of harming others?'
export const QUESTION2 =
    'Do you have any current or pending legal issues or are you being advised by a court judge, parole officer, or CPS to seek  mental health care or assessment?'
export const QUESTION3 =
    'Please select if you have ever experienced or suffered from any of the following in the past or present?'
export const QUESTION4 = 'The specialty you have chosen for this appointment'
export const QUESTION5 = 'Select your preferred location for this appointment'

export const SUICIDAL_WARNING =
    'If you are experiencing a crisis or emergency, please dial 911. You may also access the free 24-hour National Suicide Prevention Lifeline at 1-800-273-8255 (1-800-273-TALK).'

export const stateList = [
    { state: 'AK', stateLabel: 'Alaska' },
    { state: 'AL', stateLabel: 'Alabama' },
    { state: 'AR', stateLabel: 'Arkansas' },
    { state: 'AZ', stateLabel: 'Arizona' },
    { state: 'CA', stateLabel: 'California' },
    { state: 'CO', stateLabel: 'Colorado' },
    { state: 'CT', stateLabel: 'Connecticut' },
    { state: 'DC', stateLabel: 'Districtof Columbia' },
    { state: 'DE', stateLabel: 'Delaware' },
    { state: 'FL', stateLabel: 'Florida' },
    { state: 'GA', stateLabel: 'Georgia' },
    { state: 'HI', stateLabel: 'Hawaii' },
    { state: 'IA', stateLabel: 'Iowa' },
    { state: 'ID', stateLabel: 'Idaho' },
    { state: 'IL', stateLabel: 'Illinois' },
    { state: 'IN', stateLabel: 'Indiana' },
    { state: 'KS', stateLabel: 'Kansas' },
    { state: 'KY', stateLabel: 'Kentucky' },
    { state: 'LA', stateLabel: 'Louisiana' },
    { state: 'MA', stateLabel: 'Massachusetts' },
    { state: 'MD', stateLabel: 'Maryland' },
    { state: 'ME', stateLabel: 'Maine' },
    { state: 'MI', stateLabel: 'Michigan' },
    { state: 'MN', stateLabel: 'Minnesota' },
    { state: 'MO', stateLabel: 'Missouri' },
    { state: 'MS', stateLabel: 'Mississippi' },
    { state: 'MT', stateLabel: 'Montana' },
    { state: 'NC', stateLabel: 'North Carolina' },
    { state: 'ND', stateLabel: 'North Dakota' },
    { state: 'NE', stateLabel: 'Nebraska' },
    { state: 'NH', stateLabel: 'New Hampshire' },
    { state: 'NJ', stateLabel: 'New Jersey' },
    { state: 'NM', stateLabel: 'New Mexico' },
    { state: 'NV', stateLabel: 'Nevada' },
    { state: 'NY', stateLabel: 'New York' },
    { state: 'OH', stateLabel: 'Ohio' },
    { state: 'OK', stateLabel: 'Oklahoma' },
    { state: 'OR', stateLabel: 'Oregon' },
    { state: 'PA', stateLabel: 'Pennsylvania' },
    { state: 'RI', stateLabel: 'Rhode Island' },
    { state: 'SC', stateLabel: 'South Carolina' },
    { state: 'SD', stateLabel: 'South Dakota' },
    { state: 'TN', stateLabel: 'Tennessee' },
    { state: 'TX', stateLabel: 'Texas' },
    { state: 'UT', stateLabel: 'Utah' },
    { state: 'VA', stateLabel: 'Virginia' },
    { state: 'VT', stateLabel: 'Vermont' },
    { state: 'WA', stateLabel: 'Washington' },
    { state: 'WI', stateLabel: 'Wisconsin' },
    { state: 'WV', stateLabel: 'West Virginia' },
    { state: 'WY', stateLabel: 'Wyoming' },
].sort((p, q) => p.stateLabel.localeCompare(q.stateLabel))

export const preferredlanguageList = [
    {
        "id": 186,
        "description": "Declined to Specify"
    },
    {
        "id": 1,
        "description": "Abkhazian"
    },
    {
        "id": 190,
        "description": "Achinese"
    },
    {
        "id": 191,
        "description": "Acoli"
    },
    {
        "id": 192,
        "description": "Adangme"
    },
    {
        "id": 193,
        "description": "Adyghe; Adygei"
    },
    {
        "id": 2,
        "description": "Afar"
    },
    {
        "id": 195,
        "description": "Afrihili"
    },
    {
        "id": 3,
        "description": "Afrikaans"
    },
    {
        "id": 194,
        "description": "Afro-Asiatic languages"
    },
    {
        "id": 196,
        "description": "Ainu"
    },
    {
        "id": 4,
        "description": "Akan"
    },
    {
        "id": 197,
        "description": "Akkadian"
    },
    {
        "id": 5,
        "description": "Albanian"
    },
    {
        "id": 198,
        "description": "Aleut"
    },
    {
        "id": 199,
        "description": "Algonquian languages"
    },
    {
        "id": 463,
        "description": "Altaic languages"
    },
    {
        "id": 6,
        "description": "Amharic"
    },
    {
        "id": 202,
        "description": "Angika"
    },
    {
        "id": 203,
        "description": "Apache languages"
    },
    {
        "id": 7,
        "description": "Arabic"
    },
    {
        "id": 8,
        "description": "Aragonese"
    },
    {
        "id": 206,
        "description": "Arapaho"
    },
    {
        "id": 208,
        "description": "Arawak"
    },
    {
        "id": 9,
        "description": "Armenian"
    },
    {
        "id": 414,
        "description": "Aromanian; Arumanian; Macedo-Romanian"
    },
    {
        "id": 207,
        "description": "Artificial languages"
    },
    {
        "id": 10,
        "description": "Assamese"
    },
    {
        "id": 185,
        "description": "Assyrian Neo-Aramaic"
    },
    {
        "id": 209,
        "description": "Asturian; Bable; Leonese; Asturleonese"
    },
    {
        "id": 210,
        "description": "Athapascan languages"
    },
    {
        "id": 211,
        "description": "Australian languages"
    },
    {
        "id": 354,
        "description": "Austronesian languages"
    },
    {
        "id": 11,
        "description": "Avaric"
    },
    {
        "id": 12,
        "description": "Avestan"
    },
    {
        "id": 212,
        "description": "Awadhi"
    },
    {
        "id": 13,
        "description": "Aymara"
    },
    {
        "id": 14,
        "description": "Azerbaijani"
    },
    {
        "id": 216,
        "description": "Balinese"
    },
    {
        "id": 218,
        "description": "Baltic languages"
    },
    {
        "id": 215,
        "description": "Baluchi"
    },
    {
        "id": 15,
        "description": "Bambara"
    },
    {
        "id": 214,
        "description": "Bamileke languages"
    },
    {
        "id": 213,
        "description": "Banda languages"
    },
    {
        "id": 226,
        "description": "Bantu languages"
    },
    {
        "id": 217,
        "description": "Basa"
    },
    {
        "id": 16,
        "description": "Bashkir"
    },
    {
        "id": 17,
        "description": "Basque"
    },
    {
        "id": 228,
        "description": "Batak languages"
    },
    {
        "id": 219,
        "description": "Beja; Bedawiyet"
    },
    {
        "id": 18,
        "description": "Belarusian"
    },
    {
        "id": 220,
        "description": "Bemba"
    },
    {
        "id": 19,
        "description": "Bengali"
    },
    {
        "id": 221,
        "description": "Berber languages"
    },
    {
        "id": 222,
        "description": "Bhojpuri"
    },
    {
        "id": 20,
        "description": "Bihari languages"
    },
    {
        "id": 223,
        "description": "Bikol"
    },
    {
        "id": 224,
        "description": "Bini; Edo"
    },
    {
        "id": 21,
        "description": "Bislama"
    },
    {
        "id": 231,
        "description": "Blin; Bilin"
    },
    {
        "id": 482,
        "description": "Blissymbols; Blissymbolics; Bliss"
    },
    {
        "id": 22,
        "description": "BokmÃ¥l, Norwegian; Norwegian BokmÃ¥l"
    },
    {
        "id": 23,
        "description": "Bosnian"
    },
    {
        "id": 227,
        "description": "Braj"
    },
    {
        "id": 24,
        "description": "Breton"
    },
    {
        "id": 230,
        "description": "Buginese"
    },
    {
        "id": 25,
        "description": "Bulgarian"
    },
    {
        "id": 229,
        "description": "Buriat"
    },
    {
        "id": 26,
        "description": "Burmese"
    },
    {
        "id": 232,
        "description": "Caddo"
    },
    {
        "id": 27,
        "description": "Catalan; Valencian"
    },
    {
        "id": 235,
        "description": "Caucasian languages"
    },
    {
        "id": 236,
        "description": "Cebuano"
    },
    {
        "id": 237,
        "description": "Celtic languages"
    },
    {
        "id": 233,
        "description": "Central American Indian languages"
    },
    {
        "id": 28,
        "description": "Central Khmer"
    },
    {
        "id": 239,
        "description": "Chagatai"
    },
    {
        "id": 247,
        "description": "Chamic languages"
    },
    {
        "id": 29,
        "description": "Chamorro"
    },
    {
        "id": 30,
        "description": "Chechen"
    },
    {
        "id": 245,
        "description": "Cherokee"
    },
    {
        "id": 246,
        "description": "Cheyenne"
    },
    {
        "id": 238,
        "description": "Chibcha"
    },
    {
        "id": 31,
        "description": "Chichewa; Chewa; Nyanja"
    },
    {
        "id": 32,
        "description": "Chinese"
    },
    {
        "id": 242,
        "description": "Chinook jargon"
    },
    {
        "id": 244,
        "description": "Chipewyan; Dene Suline"
    },
    {
        "id": 243,
        "description": "Choctaw"
    },
    {
        "id": 33,
        "description": "Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic"
    },
    {
        "id": 240,
        "description": "Chuukese"
    },
    {
        "id": 34,
        "description": "Chuvash"
    },
    {
        "id": 389,
        "description": "Classical Newari; Old Newari; Classical Nepal Bhasa"
    },
    {
        "id": 446,
        "description": "Classical Syriac"
    },
    {
        "id": 248,
        "description": "Coptic"
    },
    {
        "id": 35,
        "description": "Cornish"
    },
    {
        "id": 36,
        "description": "Corsican"
    },
    {
        "id": 37,
        "description": "Cree"
    },
    {
        "id": 371,
        "description": "Creek"
    },
    {
        "id": 253,
        "description": "Creoles and pidgins"
    },
    {
        "id": 249,
        "description": "Creoles and pidgins, English based"
    },
    {
        "id": 250,
        "description": "Creoles and pidgins, French-based"
    },
    {
        "id": 251,
        "description": "Creoles and pidgins, Portuguese-based"
    },
    {
        "id": 252,
        "description": "Crimean Tatar; Crimean Turkish"
    },
    {
        "id": 38,
        "description": "Croatian"
    },
    {
        "id": 255,
        "description": "Cushitic languages"
    },
    {
        "id": 39,
        "description": "Czech"
    },
    {
        "id": 256,
        "description": "Dakota"
    },
    {
        "id": 40,
        "description": "Danish"
    },
    {
        "id": 257,
        "description": "Dargwa"
    },
    {
        "id": 259,
        "description": "Delaware"
    },
    {
        "id": 262,
        "description": "Dinka"
    },
    {
        "id": 41,
        "description": "Divehi; Dhivehi; Maldivian"
    },
    {
        "id": 263,
        "description": "Dogri"
    },
    {
        "id": 261,
        "description": "Dogrib"
    },
    {
        "id": 264,
        "description": "Dravidian languages"
    },
    {
        "id": 266,
        "description": "Duala"
    },
    {
        "id": 267,
        "description": "Dutch, Middle (ca.1050-1350)"
    },
    {
        "id": 42,
        "description": "Dutch; Flemish"
    },
    {
        "id": 268,
        "description": "Dyula"
    },
    {
        "id": 43,
        "description": "Dzongkha"
    },
    {
        "id": 283,
        "description": "Eastern Frisian"
    },
    {
        "id": 269,
        "description": "Efik"
    },
    {
        "id": 270,
        "description": "Egyptian (Ancient)"
    },
    {
        "id": 271,
        "description": "Ekajuk"
    },
    {
        "id": 272,
        "description": "Elamite"
    },
    {
        "id": 44,
        "description": "English"
    },
    {
        "id": 273,
        "description": "English, Middle (1100-1500)"
    },
    {
        "id": 201,
        "description": "English, Old (ca.450-1100)"
    },
    {
        "id": 375,
        "description": "Erzya"
    },
    {
        "id": 45,
        "description": "Esperanto"
    },
    {
        "id": 46,
        "description": "Estonian"
    },
    {
        "id": 47,
        "description": "Ewe"
    },
    {
        "id": 274,
        "description": "Ewondo"
    },
    {
        "id": 275,
        "description": "Fang"
    },
    {
        "id": 276,
        "description": "Fanti"
    },
    {
        "id": 48,
        "description": "Faroese"
    },
    {
        "id": 49,
        "description": "Fijian"
    },
    {
        "id": 277,
        "description": "Filipino; Pilipino"
    },
    {
        "id": 50,
        "description": "Finnish"
    },
    {
        "id": 278,
        "description": "Finno-Ugrian languages"
    },
    {
        "id": 279,
        "description": "Fon"
    },
    {
        "id": 51,
        "description": "French"
    },
    {
        "id": 280,
        "description": "French, Middle (ca.1400-1600)"
    },
    {
        "id": 281,
        "description": "French, Old (842-ca.1400)"
    },
    {
        "id": 284,
        "description": "Friulian"
    },
    {
        "id": 52,
        "description": "Fulah"
    },
    {
        "id": 285,
        "description": "Ga"
    },
    {
        "id": 53,
        "description": "Gaelic; Scottish Gaelic"
    },
    {
        "id": 234,
        "description": "Galibi Carib"
    },
    {
        "id": 54,
        "description": "Galician"
    },
    {
        "id": 55,
        "description": "Ganda"
    },
    {
        "id": 286,
        "description": "Gayo"
    },
    {
        "id": 287,
        "description": "Gbaya"
    },
    {
        "id": 289,
        "description": "Geez"
    },
    {
        "id": 56,
        "description": "Georgian"
    },
    {
        "id": 57,
        "description": "German"
    },
    {
        "id": 291,
        "description": "German, Middle High (ca.1050-1500)"
    },
    {
        "id": 292,
        "description": "German, Old High (ca.750-1050)"
    },
    {
        "id": 288,
        "description": "Germanic languages"
    },
    {
        "id": 290,
        "description": "Gilbertese"
    },
    {
        "id": 293,
        "description": "Gondi"
    },
    {
        "id": 294,
        "description": "Gorontalo"
    },
    {
        "id": 295,
        "description": "Gothic"
    },
    {
        "id": 296,
        "description": "Grebo"
    },
    {
        "id": 297,
        "description": "Greek, Ancient (to 1453)"
    },
    {
        "id": 58,
        "description": "Greek, Modern (1453-)"
    },
    {
        "id": 59,
        "description": "Guarani"
    },
    {
        "id": 60,
        "description": "Gujarati"
    },
    {
        "id": 299,
        "description": "Gwich'in"
    },
    {
        "id": 300,
        "description": "Haida"
    },
    {
        "id": 61,
        "description": "Haitian; Haitian Creole"
    },
    {
        "id": 62,
        "description": "Hausa"
    },
    {
        "id": 301,
        "description": "Hawaiian"
    },
    {
        "id": 63,
        "description": "Hebrew"
    },
    {
        "id": 64,
        "description": "Herero"
    },
    {
        "id": 302,
        "description": "Hiligaynon"
    },
    {
        "id": 303,
        "description": "Himachali languages; Western Pahari languages"
    },
    {
        "id": 65,
        "description": "Hindi"
    },
    {
        "id": 66,
        "description": "Hiri Motu"
    },
    {
        "id": 304,
        "description": "Hittite"
    },
    {
        "id": 187,
        "description": "Hmong; Mong"
    },
    {
        "id": 67,
        "description": "Hungarian"
    },
    {
        "id": 306,
        "description": "Hupa"
    },
    {
        "id": 307,
        "description": "Iban"
    },
    {
        "id": 68,
        "description": "Icelandic"
    },
    {
        "id": 69,
        "description": "Ido"
    },
    {
        "id": 70,
        "description": "Igbo"
    },
    {
        "id": 308,
        "description": "Ijo languages"
    },
    {
        "id": 309,
        "description": "Iloko"
    },
    {
        "id": 435,
        "description": "Inari Sami"
    },
    {
        "id": 310,
        "description": "Indic languages"
    },
    {
        "id": 311,
        "description": "Indo-European languages"
    },
    {
        "id": 71,
        "description": "Indonesian"
    },
    {
        "id": 312,
        "description": "Ingush"
    },
    {
        "id": 72,
        "description": "Interlingua (International Auxiliary Language Association)"
    },
    {
        "id": 73,
        "description": "Interlingue; Occidental"
    },
    {
        "id": 74,
        "description": "Inuktitut"
    },
    {
        "id": 75,
        "description": "Inupiaq"
    },
    {
        "id": 313,
        "description": "Iranian languages"
    },
    {
        "id": 76,
        "description": "Irish"
    },
    {
        "id": 359,
        "description": "Irish, Middle (900-1200)"
    },
    {
        "id": 426,
        "description": "Irish, Old (to 900)"
    },
    {
        "id": 314,
        "description": "Iroquoian languages"
    },
    {
        "id": 77,
        "description": "Italian"
    },
    {
        "id": 78,
        "description": "Japanese"
    },
    {
        "id": 79,
        "description": "Javanese"
    },
    {
        "id": 317,
        "description": "Judeo-Arabic"
    },
    {
        "id": 316,
        "description": "Judeo-Persian"
    },
    {
        "id": 324,
        "description": "Kabardian"
    },
    {
        "id": 319,
        "description": "Kabyle"
    },
    {
        "id": 320,
        "description": "Kachin; Jingpho"
    },
    {
        "id": 80,
        "description": "Kalaallisut; Greenlandic"
    },
    {
        "id": 477,
        "description": "Kalmyk; Oirat"
    },
    {
        "id": 321,
        "description": "Kamba"
    },
    {
        "id": 81,
        "description": "Kannada"
    },
    {
        "id": 82,
        "description": "Kanuri"
    },
    {
        "id": 318,
        "description": "Kara-Kalpak"
    },
    {
        "id": 332,
        "description": "Karachay-Balkar"
    },
    {
        "id": 333,
        "description": "Karelian"
    },
    {
        "id": 322,
        "description": "Karen languages"
    },
    {
        "id": 83,
        "description": "Kashmiri"
    },
    {
        "id": 254,
        "description": "Kashubian"
    },
    {
        "id": 323,
        "description": "Kawi"
    },
    {
        "id": 84,
        "description": "Kazakh"
    },
    {
        "id": 325,
        "description": "Khasi"
    },
    {
        "id": 326,
        "description": "Khoisan languages"
    },
    {
        "id": 327,
        "description": "Khotanese; Sakan"
    },
    {
        "id": 85,
        "description": "Kikuyu; Gikuyu"
    },
    {
        "id": 328,
        "description": "Kimbundu"
    },
    {
        "id": 86,
        "description": "Kinyarwanda"
    },
    {
        "id": 87,
        "description": "Kirghiz; Kyrgyz"
    },
    {
        "id": 455,
        "description": "Klingon; tlhIngan-Hol"
    },
    {
        "id": 88,
        "description": "Komi"
    },
    {
        "id": 89,
        "description": "Kongo"
    },
    {
        "id": 329,
        "description": "Konkani"
    },
    {
        "id": 90,
        "description": "Korean"
    },
    {
        "id": 330,
        "description": "Kosraean"
    },
    {
        "id": 331,
        "description": "Kpelle"
    },
    {
        "id": 334,
        "description": "Kru languages"
    },
    {
        "id": 91,
        "description": "Kuanyama; Kwanyama"
    },
    {
        "id": 336,
        "description": "Kumyk"
    },
    {
        "id": 92,
        "description": "Kurdish"
    },
    {
        "id": 335,
        "description": "Kurukh"
    },
    {
        "id": 337,
        "description": "Kutenai"
    },
    {
        "id": 338,
        "description": "Ladino"
    },
    {
        "id": 339,
        "description": "Lahnda"
    },
    {
        "id": 340,
        "description": "Lamba"
    },
    {
        "id": 258,
        "description": "Land Dayak languages"
    },
    {
        "id": 93,
        "description": "Lao"
    },
    {
        "id": 94,
        "description": "Latin"
    },
    {
        "id": 95,
        "description": "Latvian"
    },
    {
        "id": 341,
        "description": "Lezghian"
    },
    {
        "id": 96,
        "description": "Limburgan; Limburger; Limburgish"
    },
    {
        "id": 97,
        "description": "Lingala"
    },
    {
        "id": 98,
        "description": "Lithuanian"
    },
    {
        "id": 315,
        "description": "Lojban"
    },
    {
        "id": 379,
        "description": "Low German; Low Saxon; German, Low; Saxon, Low"
    },
    {
        "id": 265,
        "description": "Lower Sorbian"
    },
    {
        "id": 343,
        "description": "Lozi"
    },
    {
        "id": 99,
        "description": "Luba-Katanga"
    },
    {
        "id": 344,
        "description": "Luba-Lulua"
    },
    {
        "id": 345,
        "description": "Luiseno"
    },
    {
        "id": 434,
        "description": "Lule Sami"
    },
    {
        "id": 346,
        "description": "Lunda"
    },
    {
        "id": 347,
        "description": "Luo (Kenya and Tanzania)"
    },
    {
        "id": 348,
        "description": "Lushai"
    },
    {
        "id": 100,
        "description": "Luxembourgish; Letzeburgesch"
    },
    {
        "id": 101,
        "description": "Macedonian"
    },
    {
        "id": 349,
        "description": "Madurese"
    },
    {
        "id": 350,
        "description": "Magahi"
    },
    {
        "id": 351,
        "description": "Maithili"
    },
    {
        "id": 352,
        "description": "Makasar"
    },
    {
        "id": 102,
        "description": "Malagasy"
    },
    {
        "id": 103,
        "description": "Malay"
    },
    {
        "id": 104,
        "description": "Malayalam"
    },
    {
        "id": 105,
        "description": "Maltese"
    },
    {
        "id": 364,
        "description": "Manchu"
    },
    {
        "id": 357,
        "description": "Mandar"
    },
    {
        "id": 353,
        "description": "Mandingo"
    },
    {
        "id": 365,
        "description": "Manipuri"
    },
    {
        "id": 366,
        "description": "Manobo languages"
    },
    {
        "id": 106,
        "description": "Manx"
    },
    {
        "id": 107,
        "description": "Maori"
    },
    {
        "id": 205,
        "description": "Mapudungun; Mapuche"
    },
    {
        "id": 108,
        "description": "Marathi"
    },
    {
        "id": 241,
        "description": "Mari"
    },
    {
        "id": 109,
        "description": "Marshallese"
    },
    {
        "id": 373,
        "description": "Marwari"
    },
    {
        "id": 355,
        "description": "Masai"
    },
    {
        "id": 374,
        "description": "Mayan languages"
    },
    {
        "id": 358,
        "description": "Mende"
    },
    {
        "id": 360,
        "description": "Mi'kmaq; Micmac"
    },
    {
        "id": 361,
        "description": "Minangkabau"
    },
    {
        "id": 372,
        "description": "Mirandese"
    },
    {
        "id": 367,
        "description": "Mohawk"
    },
    {
        "id": 356,
        "description": "Moksha"
    },
    {
        "id": 363,
        "description": "Mon-Khmer languages"
    },
    {
        "id": 342,
        "description": "Mongo"
    },
    {
        "id": 110,
        "description": "Mongolian"
    },
    {
        "id": 488,
        "description": "Montenegrin"
    },
    {
        "id": 368,
        "description": "Mossi"
    },
    {
        "id": 369,
        "description": "Multiple languages"
    },
    {
        "id": 370,
        "description": "Munda languages"
    },
    {
        "id": 386,
        "description": "N'Ko"
    },
    {
        "id": 376,
        "description": "Nahuatl languages"
    },
    {
        "id": 111,
        "description": "Nauru"
    },
    {
        "id": 112,
        "description": "Navajo; Navaho"
    },
    {
        "id": 113,
        "description": "Ndebele, North; North Ndebele"
    },
    {
        "id": 114,
        "description": "Ndebele, South; South Ndebele"
    },
    {
        "id": 115,
        "description": "Ndonga"
    },
    {
        "id": 378,
        "description": "Neapolitan"
    },
    {
        "id": 380,
        "description": "Nepal Bhasa; Newari"
    },
    {
        "id": 116,
        "description": "Nepali"
    },
    {
        "id": 381,
        "description": "Nias"
    },
    {
        "id": 382,
        "description": "Niger-Kordofanian languages"
    },
    {
        "id": 442,
        "description": "Nilo-Saharan languages"
    },
    {
        "id": 383,
        "description": "Niuean"
    },
    {
        "id": 486,
        "description": "No linguistic content; Not applicable"
    },
    {
        "id": 384,
        "description": "Nogai"
    },
    {
        "id": 385,
        "description": "Norse, Old"
    },
    {
        "id": 377,
        "description": "North American Indian languages"
    },
    {
        "id": 282,
        "description": "Northern Frisian"
    },
    {
        "id": 117,
        "description": "Northern Sami"
    },
    {
        "id": 118,
        "description": "Norwegian"
    },
    {
        "id": 119,
        "description": "Norwegian Nynorsk; Nynorsk, Norwegian"
    },
    {
        "id": 388,
        "description": "Nubian languages"
    },
    {
        "id": 390,
        "description": "Nyamwezi"
    },
    {
        "id": 391,
        "description": "Nyankole"
    },
    {
        "id": 392,
        "description": "Nyoro"
    },
    {
        "id": 393,
        "description": "Nzima"
    },
    {
        "id": 120,
        "description": "Occitan (post 1500)"
    },
    {
        "id": 204,
        "description": "Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)"
    },
    {
        "id": 121,
        "description": "Ojibwa"
    },
    {
        "id": 122,
        "description": "Oriya"
    },
    {
        "id": 123,
        "description": "Oromo"
    },
    {
        "id": 394,
        "description": "Osage"
    },
    {
        "id": 124,
        "description": "Ossetian; Ossetic"
    },
    {
        "id": 189,
        "description": "Other"
    },
    {
        "id": 396,
        "description": "Otomian languages"
    },
    {
        "id": 399,
        "description": "Pahlavi"
    },
    {
        "id": 402,
        "description": "Palauan"
    },
    {
        "id": 125,
        "description": "Pali"
    },
    {
        "id": 400,
        "description": "Pampanga; Kapampangan"
    },
    {
        "id": 398,
        "description": "Pangasinan"
    },
    {
        "id": 126,
        "description": "Panjabi; Punjabi"
    },
    {
        "id": 401,
        "description": "Papiamento"
    },
    {
        "id": 397,
        "description": "Papuan languages"
    },
    {
        "id": 387,
        "description": "Pedi; Sepedi; Northern Sotho"
    },
    {
        "id": 127,
        "description": "Persian"
    },
    {
        "id": 403,
        "description": "Persian, Old (ca.600-400 B.C.)"
    },
    {
        "id": 404,
        "description": "Philippine languages"
    },
    {
        "id": 405,
        "description": "Phoenician"
    },
    {
        "id": 406,
        "description": "Pohnpeian"
    },
    {
        "id": 128,
        "description": "Polish"
    },
    {
        "id": 129,
        "description": "Portuguese"
    },
    {
        "id": 407,
        "description": "Prakrit languages"
    },
    {
        "id": 408,
        "description": "ProvenÃ§al, Old (to 1500);Occitan, Old (to 1500)"
    },
    {
        "id": 130,
        "description": "Pushto; Pashto"
    },
    {
        "id": 131,
        "description": "Quechua"
    },
    {
        "id": 409,
        "description": "Rajasthani"
    },
    {
        "id": 410,
        "description": "Rapanui"
    },
    {
        "id": 411,
        "description": "Rarotongan; Cook Islands Maori"
    },
    {
        "id": 412,
        "description": "Romance languages"
    },
    {
        "id": 132,
        "description": "Romanian; Moldavian; Moldovan"
    },
    {
        "id": 133,
        "description": "Romansh"
    },
    {
        "id": 413,
        "description": "Romany"
    },
    {
        "id": 134,
        "description": "Rundi"
    },
    {
        "id": 135,
        "description": "Russian"
    },
    {
        "id": 418,
        "description": "Salishan languages"
    },
    {
        "id": 419,
        "description": "Samaritan Aramaic"
    },
    {
        "id": 433,
        "description": "Sami languages"
    },
    {
        "id": 136,
        "description": "Samoan"
    },
    {
        "id": 415,
        "description": "Sandawe"
    },
    {
        "id": 137,
        "description": "Sango"
    },
    {
        "id": 138,
        "description": "Sanskrit"
    },
    {
        "id": 421,
        "description": "Santali"
    },
    {
        "id": 139,
        "description": "Sardinian"
    },
    {
        "id": 420,
        "description": "Sasak"
    },
    {
        "id": 423,
        "description": "Scots"
    },
    {
        "id": 424,
        "description": "Selkup"
    },
    {
        "id": 425,
        "description": "Semitic languages"
    },
    {
        "id": 140,
        "description": "Serbian"
    },
    {
        "id": 441,
        "description": "Serer"
    },
    {
        "id": 427,
        "description": "Shan"
    },
    {
        "id": 141,
        "description": "Shona"
    },
    {
        "id": 142,
        "description": "Sichuan Yi; Nuosu"
    },
    {
        "id": 422,
        "description": "Sicilian"
    },
    {
        "id": 428,
        "description": "Sidamo"
    },
    {
        "id": 188,
        "description": "Sign Languages"
    },
    {
        "id": 225,
        "description": "Siksika"
    },
    {
        "id": 143,
        "description": "Sindhi"
    },
    {
        "id": 144,
        "description": "Sinhala; Sinhalese"
    },
    {
        "id": 430,
        "description": "Sino-Tibetan languages"
    },
    {
        "id": 429,
        "description": "Siouan languages"
    },
    {
        "id": 436,
        "description": "Skolt Sami"
    },
    {
        "id": 260,
        "description": "Slave (Athapascan)"
    },
    {
        "id": 431,
        "description": "Slavic languages"
    },
    {
        "id": 145,
        "description": "Slovak"
    },
    {
        "id": 146,
        "description": "Slovenian"
    },
    {
        "id": 438,
        "description": "Sogdian"
    },
    {
        "id": 147,
        "description": "Somali"
    },
    {
        "id": 439,
        "description": "Songhai languages"
    },
    {
        "id": 437,
        "description": "Soninke"
    },
    {
        "id": 476,
        "description": "Sorbian languages"
    },
    {
        "id": 148,
        "description": "Sotho, Southern"
    },
    {
        "id": 417,
        "description": "South American Indian languages"
    },
    {
        "id": 200,
        "description": "Southern Altai"
    },
    {
        "id": 432,
        "description": "Southern Sami"
    },
    {
        "id": 149,
        "description": "Spanish"
    },
    {
        "id": 440,
        "description": "Sranan Tongo"
    },
    {
        "id": 489,
        "description": "Standard Moroccan Tamazight"
    },
    {
        "id": 443,
        "description": "Sukuma"
    },
    {
        "id": 445,
        "description": "Sumerian"
    },
    {
        "id": 150,
        "description": "Sundanese"
    },
    {
        "id": 444,
        "description": "Susu"
    },
    {
        "id": 151,
        "description": "Swahili"
    },
    {
        "id": 152,
        "description": "Swati"
    },
    {
        "id": 153,
        "description": "Swedish"
    },
    {
        "id": 298,
        "description": "Swiss German; Alemannic; Alsatian"
    },
    {
        "id": 447,
        "description": "Syriac"
    },
    {
        "id": 154,
        "description": "Tagalog"
    },
    {
        "id": 155,
        "description": "Tahitian"
    },
    {
        "id": 448,
        "description": "Tai languages"
    },
    {
        "id": 156,
        "description": "Tajik"
    },
    {
        "id": 457,
        "description": "Tamashek"
    },
    {
        "id": 157,
        "description": "Tamil"
    },
    {
        "id": 158,
        "description": "Tatar"
    },
    {
        "id": 159,
        "description": "Telugu"
    },
    {
        "id": 450,
        "description": "Tereno"
    },
    {
        "id": 451,
        "description": "Tetum"
    },
    {
        "id": 160,
        "description": "Thai"
    },
    {
        "id": 161,
        "description": "Tibetan"
    },
    {
        "id": 452,
        "description": "Tigre"
    },
    {
        "id": 162,
        "description": "Tigrinya"
    },
    {
        "id": 449,
        "description": "Timne"
    },
    {
        "id": 453,
        "description": "Tiv"
    },
    {
        "id": 456,
        "description": "Tlingit"
    },
    {
        "id": 459,
        "description": "Tok Pisin"
    },
    {
        "id": 454,
        "description": "Tokelau"
    },
    {
        "id": 458,
        "description": "Tonga (Nyasa)"
    },
    {
        "id": 163,
        "description": "Tonga (Tonga Islands)"
    },
    {
        "id": 460,
        "description": "Tsimshian"
    },
    {
        "id": 164,
        "description": "Tsonga"
    },
    {
        "id": 165,
        "description": "Tswana"
    },
    {
        "id": 461,
        "description": "Tumbuka"
    },
    {
        "id": 462,
        "description": "Tupi languages"
    },
    {
        "id": 166,
        "description": "Turkish"
    },
    {
        "id": 395,
        "description": "Turkish, Ottoman (1500-1928)"
    },
    {
        "id": 167,
        "description": "Turkmen"
    },
    {
        "id": 464,
        "description": "Tuvalu"
    },
    {
        "id": 465,
        "description": "Tuvinian"
    },
    {
        "id": 168,
        "description": "Twi"
    },
    {
        "id": 466,
        "description": "Udmurt"
    },
    {
        "id": 467,
        "description": "Ugaritic"
    },
    {
        "id": 169,
        "description": "Uighur; Uyghur"
    },
    {
        "id": 170,
        "description": "Ukrainian"
    },
    {
        "id": 468,
        "description": "Umbundu"
    },
    {
        "id": 362,
        "description": "Uncoded languages"
    },
    {
        "id": 469,
        "description": "Undetermined"
    },
    {
        "id": 305,
        "description": "Upper Sorbian"
    },
    {
        "id": 171,
        "description": "Urdu"
    },
    {
        "id": 172,
        "description": "Uzbek"
    },
    {
        "id": 470,
        "description": "Vai"
    },
    {
        "id": 173,
        "description": "Venda"
    },
    {
        "id": 174,
        "description": "Vietnamese"
    },
    {
        "id": 175,
        "description": "VolapÃ¼k"
    },
    {
        "id": 471,
        "description": "Votic"
    },
    {
        "id": 472,
        "description": "Wakashan languages"
    },
    {
        "id": 176,
        "description": "Walloon"
    },
    {
        "id": 474,
        "description": "Waray"
    },
    {
        "id": 475,
        "description": "Washo"
    },
    {
        "id": 177,
        "description": "Welsh"
    },
    {
        "id": 178,
        "description": "Western Frisian"
    },
    {
        "id": 473,
        "description": "Wolaitta; Wolaytta"
    },
    {
        "id": 179,
        "description": "Wolof"
    },
    {
        "id": 180,
        "description": "Xhosa"
    },
    {
        "id": 416,
        "description": "Yakut"
    },
    {
        "id": 478,
        "description": "Yao"
    },
    {
        "id": 479,
        "description": "Yapese"
    },
    {
        "id": 181,
        "description": "Yiddish"
    },
    {
        "id": 182,
        "description": "Yoruba"
    },
    {
        "id": 480,
        "description": "Yupik languages"
    },
    {
        "id": 484,
        "description": "Zande languages"
    },
    {
        "id": 481,
        "description": "Zapotec"
    },
    {
        "id": 487,
        "description": "Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki"
    },
    {
        "id": 483,
        "description": "Zenaga"
    },
    {
        "id": 183,
        "description": "Zhuang; Chuang"
    },
    {
        "id": 184,
        "description": "Zulu"
    },
    {
        "id": 485,
        "description": "Zuni"
    }
].sort((a, b) => a.description.localeCompare(b.description))

export const relationshipOptions = [
    { key: "18", value: "Self" },
    { key: "01", value: "Spouse" },
    { key: "19", value: "Child" },
    { key: "G8", value: "Other Relationship" }

    // { key: "04", value: "Grandfather or Grandmother" },
    // { key: "05", value: "Grandson or Granddaughter" },
    // { key: "07", value: "Nephew or Niece" },
    // { key: "09", value: "Adopted Child" },
    // { key: "10", value: "Foster Child" },
    // { key: "15", value: "Ward" },
    // { key: "17", value: "Stepson or Stepdaughter" },
    // { key: "20", value: "Employee" },
    // { key: "21", value: "Unknown" },
    // { key: "22", value: "Handicapped Dependent" },
    // { key: "23", value: "Sponsored Dependent" },
    // { key: "24", value: "Dependent of a Minor Dependent" },
    // { key: "29", value: "Significant Other" },
    // { key: "32", value: "Mother" },
    // { key: "33", value: "Father" },
    // { key: "34", value: "Other Adult" },
    // { key: "36", value: "Emancipated Minor" },
    // { key: "39", value: "Organ Donor" },
    // { key: "40", value: "Cadaver Donor" },
    // { key: "41", value: "Injured Plaintiff" },
    // { key: "43", value: "Child Where Insured Has No Financial Responsibility" },
    // { key: "53", value: "Life Partner" },
    // { key: "G8", value: "Other Relationship" }
  ];
